import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    text = _this$get.text,
    disabled = _this$get.disabled,
    max = _this$get.max;
  if (typeof text === 'number' && max && text > max) {
    text = max + "+";
  }
  var _this$config = this.config,
    cls = _this$config.cls,
    k = _this$config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-badge"] = true, _classNameObj[className] = className, _classNameObj[k + "-has-text"] = text != null, _classNameObj[k + "-alone"] = !children, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [children, !disabled ? _$ce(2, 'sup', text, 0, _$cn(k + "-badge-text")) : undefined]);
}
;